import React, { FC } from 'react';
import { BaseButton, BaseButtonProps } from '../baseButton';

type PrimaryButtonProps = Omit<BaseButtonProps, 'buttonStyle'> & {
  'data-test-automation-id'?: string;
};

export const PrimaryButton: FC<PrimaryButtonProps> = ({
  onClick,
  className = '',
  children,
  disabled = false,
  ariaLabel,
  ariaExpanded,
  'data-test-automation-id': dataTestAutomationId,
}) => {
  return (
    <BaseButton
      onClick={onClick}
      buttonStyle="contained"
      className={`${className}`}
      disabled={disabled}
      ariaLabel={ariaLabel}
      ariaExpanded={ariaExpanded}
      data-test-automation-id={dataTestAutomationId}
    >
      {children}
    </BaseButton>
  );
};
